(function () {
	'use strict';
	$(document).ready(function () {

		activateShuffleOnVisible(".fh-shuffle", ".subpage .big-numbers");

		// SOCIAL SHARING
		$('.js-sharing-button').on('click', function() {
			$('#share').fadeToggle();
		});

		clickedOutside('#share', function() {
			$('#share').fadeOut();
		}, ['.js-sharing-button']);

		$('#share').jsSocials({
			showLabel: false,
			showCount: false,
			shareIn: "popup",
			text: document.title,
			url: window.location.href,
			shares: [
				{
					share: "facebook",
					logo: fhGetConfig('template_uri') + '/dist/images/facebook.svg',
					inlineSvg: true,
				},
				{
					share: "twitter",
					logo: fhGetConfig('template_uri') + '/dist/images/twitter.svg',
					inlineSvg: true,
					via: "GrupaPZU",
				},
				{
					share: "linkedin",
					logo: fhGetConfig('template_uri') + '/dist/images/linkedin.svg',
					inlineSvg: true,
				}
			]
		});

		//Top indexes
		$(".js-index-toggle").on('click', function () {
			$(this).closest('.index-container').siblings().find('.index-list').fadeOut();
			$(this).closest('.index-container').siblings().find('.js-index-toggle').removeClass('open');
			$(this).toggleClass('open');
			$(this).siblings('.index-list').fadeToggle();
		});

		if (window.matchMedia("(min-width: 992px)").matches) {
			ScrollTrigger.create({
				trigger: ".main-content",
				start: "top 30px",
				end: "bottom bottom",
				pin: ".menu-contents",
			});
		}

		$('.subpage .swiper-image-slider').each(function () {
			new Swiper($(this)[0], {
				loop: false,
				slidesPerView: 1,
				spaceBetween: 30,
				navigation: {
					nextEl: '.swiper-next',
					prevEl: '.swiper-prev',
				},
				pagination: {
					el: '.swiper-pagination',
					renderBullet: function (index, className) {
						return '<span class="number ' + className +'">0' + (index + 1) + '</span>';
					}
				}
			});
		});

		$('.subpage .swiper-big-numbers-3').each(function () {
			new Swiper($(this)[0], {
				loop: false,
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 15,
				breakpoints: {
					992: {
						slidesPerView: 3,
						slidesPerGroup: 3
					},
					576: {
						slidesPerView: 2,
						slidesPerGroup: 2
					}
				},
				navigation: {
					nextEl: '.swiper-next',
					prevEl: '.swiper-prev',
				},
				pagination: {
					el: '.swiper-pagination',
					type: 'custom',
					renderCustom: function (swiper, current, total) {
						return '<span class="number ' + (current > 1 ? 'active' : 'disabled') + '">0' + (current) + '</span><span class="line"></span><span class="number ' + (current === total ? 'disabled' : 'active') + '">0' + total + '</span>';
					}
				}
			});
		});

		$('.subpage .swiper-big-numbers-4').each(function () {
			new Swiper($(this)[0], {
				loop: false,
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 15,
				breakpoints: {
					992: {
						slidesPerView: 4,
						slidesPerGroup: 4
					},
					768: {
						slidesPerView: 3,
						slidesPerGroup: 3
					},
					576: {
						slidesPerView: 2,
						slidesPerGroup: 2
					}
				},
				navigation: {
					nextEl: '.swiper-next',
					prevEl: '.swiper-prev',
				},
				pagination: {
					el: '.swiper-pagination',
					type: 'custom',
					renderCustom: function (swiper, current, total) {
						return '<span class="number ' + (current > 1 ? 'active' : 'disabled') + '">0' + (current) + '</span><span class="line"></span><span class="number ' + (current === total ? 'disabled' : 'active') + '">0' + total + '</span>';
					}
				}
			});
		});

		$('.subpage .swiper-big-numbers-image').each(function () {
			const $this = $(this);
		
			const swiper = new Swiper($(this)[0], {
				loop: false,
				autoHeight: true,
				slidesPerView: 1,
				spaceBetween: 15,
				navigation: {
					nextEl: Array.from($this[0].querySelectorAll('.swiper-next')),
					prevEl: Array.from($this[0].querySelectorAll('.swiper-prev')),
				},
			});
			swiper.on('slideChange', function () {
				const activeIndex = swiper.activeIndex + 1
				$this.find('.swiper-prev .number').text(`0${activeIndex}`);
			});
		});

		$('.subpage .swiper-text-big-numbers-sliders').each(function () {
			const $this = $(this);

			const swiper = new Swiper($(this)[0], {
				loop: false,
				autoHeight: false,
				slidesPerView: 1,
				spaceBetween: 15,
				navigation: {
					nextEl: Array.from($this[0].querySelectorAll('.swiper-next')),
					prevEl: Array.from($this[0].querySelectorAll('.swiper-prev')),
				},
			});
			swiper.on('slideChange', function () {
				const activeIndex = swiper.activeIndex + 1
				$this.find('.swiper-prev .number').text(`0${activeIndex}`);
			});
		});

		// handle tables in accordions
        $('.subpage .accordion .collapse').on('shown.bs.collapse', function () {
            updateTableSize();
            $(window).resize();
        });

        // accordion scroll animation
        $('.subpage .accordion.scroll-animation .collapse').on('shown.bs.collapse', function () {
            const positionTop = $(this).parent().offset().top; // - $('header').height();
            $('html, body').animate({
                scrollTop: positionTop
            }, 500);
        });

	    // responsive-image module zoomable feature
	    document.querySelectorAll('.module.responsive-image .image-container.zoomable .desktop-image').forEach((containerElement) => {
		    const popupContainer = document.createElement('div');
		    popupContainer.classList.add('popup-image-container');
		    const clonedImg = containerElement.parentElement.querySelector('.popup-image img').cloneNode(true);
		    clonedImg.classList.add('popup-image');
		    popupContainer.appendChild(clonedImg);

		    const removePopupContainer = () => {
			    $(popupContainer).fadeOut(() => {
				    popupContainer.remove();
			    });
		    };
		    popupContainer.addEventListener('click', removePopupContainer);

		    const mediaQuery = window.matchMedia('(min-width: 768px)');
		    mediaQuery.addEventListener('change', () => {
			    if (!mediaQuery.matches) {
				    removePopupContainer();
			    }
		    })
		    containerElement.querySelector('img').addEventListener('click', () => {
			    if (mediaQuery.matches) {
				    document.body.appendChild(popupContainer);
				    $(popupContainer).fadeIn();
			    }
		    })
	    });

		$(".download").click(function() {
			$(this).find('#btn-download').addClass("downloaded");
		});

		// default tooltips
		$('.default-tooltipster').tooltipster({
			maxWidth: 290,
			contentAsHTML: true,
			interactive: true,
			functionPosition: function (instance, helper, position) {
				position.coord.left = helper.geo.origin.offset.left - 20;
				return position;
			},
		});

		ScrollTrigger.create({
			trigger: ".top",
			start: "bottom center",
			onEnter: () => gsap.to(".aside-tools", {
				autoAlpha: 1,
				delay: 0,
				duration: .5,
			}),
			onEnterBack: () => gsap.to(".aside-tools", {
				autoAlpha: 0,
				delay: 0,
				duration: .5,
			}),
			onLeave: () => gsap.to(".aside-tools", {
				autoAlpha: 1,
				delay: 0,
				duration: .5,
			}),
			onLeaveBack: () => gsap.to(".aside-tools", {
				autoAlpha: 0,
				delay: 0,
				duration: .5,
			}),
		});

	});
}(jQuery));
